import React from 'react';
import ChatboxUpload from './ChatboxUpload';
import { Formik } from 'formik';
import ChatBoxForm from '../../../../../components/Forms/ChatBoxForm';
import { createBookingMessage } from 'api/node/bookings';
import { createHotelKeeperBookingMessage } from 'api/node/hotelkeeper';
import { useError } from 'hooks';

export default function ChatboxInput({
  bookingId,
  secret,
  reload,
  privateMode = false,
}) {
  const { sendErrorSnack } = useError();
  const onSubmit = async (values) => {
    if (!values.message || values.message.trim() === '') return;

    try {
      if (secret) {
        await createHotelKeeperBookingMessage({
          data: { ...values, private: privateMode },
          secret,
        });
      } else {
        await createBookingMessage({
          data: { ...values, private: privateMode },
          bookingId,
        });
      }

      reload();
    } catch (err) {
      sendErrorSnack(err);
    }
  };

  return (
    <Formik
      initialValues={{
        adminBookingId: bookingId,
        secret: secret,
        message: '',
      }}
      onSubmit={(values, { resetForm }) =>
        onSubmit(values).then(() => resetForm())
      }
    >
      <ChatBoxForm
        costumUploaderField={
          <ChatboxUpload
            onUpload={reload}
            secret={secret}
            privateMode={privateMode}
            adminBookingId={bookingId}
          />
        }
      />
    </Formik>
  );
}
